class ShopPageStateService {
    constructor($document) {
        this.$document = $document;

        this.smallFormatMenuOpen = false;
        this.isCartOpen = false;
    }

    resetCenterPanelScroll() {
        this.$document.scrollTop(0);
    }

    toggleBodyScroll(shouldBeScrollable) {
        this.$document.find('body').toggleClass('noscroll', !shouldBeScrollable);
    }
}

ShopPageStateService.$inject = ['$document'];

module.exports = { ShopPageStateService };



// WEBPACK FOOTER //
// ./src/common/shoppagestate/shop-page-state.service.js